<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col
        v-if="template.category"
        cols="12"
      >
        <v-autocomplete
          v-model="template.category.id"
          :items="categories"
          item-text="name"
          item-value="id"
          label="Category"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
          @change="getSuggestedName"
        />
      </v-col>

      <v-col
        v-if="template.category"
        cols="12"
      >
        <v-autocomplete
          v-model="template.productId"
          :items="products"
          item-text="name"
          item-value="id"
          label="Product"
          hide-details="auto"
          outlined
          :disabled="!template.category.id"
          :rules="[$rules.required]"
          @change="getSuggestedName"
        />
      </v-col>

      <v-col
        v-if="template.designGroup"
        cols="12"
      >
        <v-autocomplete
          v-model="template.designGroup.id"
          :items="design_groups"
          item-text="name"
          item-value="id"
          label="Design Group"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
          @change="getSuggestedName"
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="template.quantity"
          label="Quantity"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>

      <v-col
        v-if="template.overrideName"
        cols="12"
      >
        <v-text-field
          v-model="template.overrideName"
          label="Template Name"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AddTemplate',

  data() {
    return {
      template: {},
      valid: false,
      saving: false,
      loading: false
    };
  },
  computed: {
    products() {
      if (!this.template.category?.id) {
        return [];
      }
      return this.productsByCategory(this.template.category.id).filter(
        (x) => x.active && x.allowTemplateCreation
      );
    },
    ...mapGetters({
      categories: 'lookup/categories',
      productsByCategory: 'lookup/productsByCategory',
      design_groups: 'lookup/design_groups'
    })
  },
  mounted() {
    this.template = {
      quantity: 1,
      overrideName: '',
      category: {},
      designGroup: {}
    };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('templates/create', this.template)
        .then(() => {
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE);
          this.$root.$snackbarSuccess('Template created');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },

    getSuggestedName() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.$store
        .dispatch('templates/getSuggestedName', Object.assign(this.template, { overrideName: '' }))
        .then((name) => {
          this.$set(this.template, 'overrideName', name);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
